import { render, staticRenderFns } from "./user-profile-detail.vue?vue&type=template&id=094e8958&scoped=true&"
import script from "./user-profile-detail.vue?vue&type=script&lang=js&"
export * from "./user-profile-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-profile-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./user-profile-detail.vue?vue&type=style&index=1&id=094e8958&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e8958",
  null
  
)

export default component.exports